<template>
  <div class="company-create-container">
      <RailbankCreate v-if="venderType ==='railbank'" />
      <ModulrCreate v-if="venderType ==='modulr'" />
  </div>
</template>

<script>
import RailbankCreate from './components/vender-railbank-create-form'
import ModulrCreate from './components/vender-modulr-create-form'
export default {
    components: {
        RailbankCreate,
        ModulrCreate
    },
    computed: {
        venderType() {
            return this.$route.params.vender_type || "railbank";
        },
    },
    
}
</script>

<style>

</style>